// extracted by mini-css-extract-plugin
export default {"xs":"374px","sm":"740px","md":"1024px","lg":"1280px","xl":"1680px","redeemSuccess":"csJd1N8DctKuYPaW_J9g","successMessage":"wyeBWnfxjT7RA1fwdVlC","successCta":"h5gPp1qsibuxra_A7aMt"};